<template>
    <span :class="['house-trend', trendStatus]">
        <i
            v-if="trendStatus === 'trend-up'"
            class="iconfont icon-arrow_03_up"
        ></i>
        <i
            v-else-if="trendStatus === 'trend-down'"
            class="iconfont icon-arrow_04_down"
        ></i>
        {{ trend }}
    </span>
</template>
<script>
export default {
    props: {
        trendStatus: {
            type: String,
            default: ''
        },
        trend: {
            type: String,
            default: ''
        }
    }
};
</script>
<style lang="scss">
.house-trend {
    font-size: 16px;
    line-height: 20px;
    font-family: var(--font-medium);
    padding-left: 10px;
    display: flex;
    align-items: center;
    .iconfont {
        margin-right: 8px;
        font-size: 12px;
    }
    &.trend-up {
        color: var(--color-success);
    }
    &.trend-down {
        color: var(--color-error);
    }
}
</style>
